import * as types from './mutations-types';

export default {
    [types.SET_USERS](state, users) {
        state.users = users;
    },

    [types.SET_SERVICES](state, services) {
        state.services = services;
    },
    
    [types.UPDATE_USER](state, updatedUser) {
        const index = state.users.findIndex(u => u.id === updatedUser.id);
        if (index !== -1) {
            state.users.splice(index, 1, updatedUser);
        }
    },
    
    [types.ADD_USER](state, newUser) {
        state.users.push(newUser);
    },
    
    [types.DELETE_USER](state, userId) {
        const index = state.users.findIndex(u => u.id === userId);
        if (index !== -1) {
            state.users.splice(index, 1);
        }
    }
};
